/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNewVariable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 16v2h2v2h-2v2h-2v-2h-2v-2h2v-2zM9.213 3C7.598 4.538 6.37 6.265 5.531 8.181a14.995 14.995 0 0 0-1.259 6.088c0 1.185.126 2.37.378 3.555.253 1.184.606 2.243 1.061 3.176H3.666c-.315-.517-.6-1.16-.852-1.929-.252-.768-.451-1.582-.596-2.439S2 14.956 2 14.174c0-1.462.196-2.886.587-4.273.391-1.386.953-2.672 1.685-3.857S5.869 3.845 6.866 3zm1.519 4.255 1.515 3.365 2.707-3.365h2.499l-4.146 4.897 2.537 5.048h-2.386l-1.76-3.687L8.744 17.2H6.226l4.392-5.237L8.27 7.255zM20.334 3c.315.517.6 1.16.852 1.929.252.768.451 1.582.596 2.439.146.857.218 1.676.218 2.458A15.62 15.62 0 0 1 21.437 14h-2.326c.402-1.374.617-2.795.617-4.269 0-1.197-.126-2.389-.378-3.573-.253-1.185-.606-2.238-1.06-3.158z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgNewVariable as NewVariable };
